export const addresses = {
  wallet: "0x1e3516211Fe0CB030802237B4C4CE8277733a3B9",
  alphabetProvider: "0x673c5bA6f6C612a2Ed2e810eD91f168F7910bE9a",
};
